<a>
  <div class="row art-box art-box-gift m-1">
    <div>
      <div>
        <h2>
          <span class="text-nowrap" *ngIf="title" [innerHTML]="title">{{ title }}</span>
        </h2>
      </div>
    </div>
  </div>
</a>
